import { FC } from 'react';
import './Badge.scss';
import { IonIcon } from '@ionic/react';
import classNames from 'classnames';
import { Color } from '@ionic/core';

export interface BadgeProps {
  /**
   * The icon to display inside the badge
   */
  icon?: string;
  /**
   * The icon color
   */
  color: Color;
  /**
   *  Whether the connection is active.
   */
  isActive?: boolean;
  /**
   * Whether the badge is large
   */
  isLarge?: boolean;
}

export const Badge: FC<BadgeProps> = ({ icon, color, isActive, isLarge }) => {
  return (
    <div className={classNames('dq-badge', `ion-color-${color}`, isActive && 'dq-badge-active')}>
      <IonIcon className={classNames('dq-badge-icon', isLarge && 'large-badge')} icon={icon} />
    </div>
  );
};
